import { c as _c } from "react/compiler-runtime";
import React from 'react';
import JBImage from 'components/essentials/JBImage';
const BUILD_YOUR_OWN_MOBILE_LINK = 'https://joybird2.imgix.net/build-your-own-sofa-mobile.svg';
const IconBuildYourOwnMobile = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <JBImage src={BUILD_YOUR_OWN_MOBILE_LINK} sizes="100vw" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default IconBuildYourOwnMobile;